import requests from "./httpService";

const PolicyServices = {
 
  getPolicyById: async (id, body) => {
    return requests.get(`/fixedItineraryPolicy/${id}`, body);
  },

  updatePolicy: async (id, body) => {
    return requests.put(`/fixedItineraryPolicy/update/${id}`, body);
  },

  
};

export default PolicyServices;
